import React from 'react'

import { LineItemTotals } from '../../../models/line-item'
import { displayRound } from '../../../filters/display-round'
import { useRegisterManager } from '../../../ng-compat/hooks'

interface Props {
  totals: LineItemTotals
}

export const LineItemTotalPrice: React.FC<Props> = ({ totals }) => {
  const registerManager = useRegisterManager()

  const totalPrice = registerManager.isTaxInclusive()
    ? totals.inclusivePrice
    : totals.exclusivePrice

  return (
    <span className="wr-li-cell-summary-price-value vd-text-label">
      {displayRound(totalPrice)}
    </span>
  )
}
